module.exports = __webpack_public_path__ + "media/images/club-logo/5-12e3b386eb6705aec49b08d5954d7307.png";